var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Network"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Network",
    clipPath: "url(#clip-Network)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_955108",
    transform: "translate(-2.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(3.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M275.954,104.5a47.948,47.948,0,0,0-.528-7.036H264.309v14.072h11.117A47.967,47.967,0,0,0,275.954,104.5Z",
    transform: "translate(-213.298 -78.374)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M274.774,187.284H264.308v15.567C268.934,201.585,272.892,195.481,274.774,187.284Z",
    transform: "translate(-213.297 -150.609)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M264.309,0V15.567h10.466C272.893,7.37,268.935,1.266,264.309,0Z",
    transform: "translate(-213.298)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M319.8,22.358A26.536,26.536,0,0,0,305.448,8.444a32.951,32.951,0,0,1,6.033,13.914Z",
    transform: "translate(-246.38 -6.79)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M339.788,104.5a53.475,53.475,0,0,1-.475,7.036h8.953a25.621,25.621,0,0,0,0-14.072h-8.953A53.511,53.511,0,0,1,339.788,104.5Z",
    transform: "translate(-273.614 -78.374)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M203.364,15.567V0c-4.626,1.266-8.584,7.37-10.466,15.567Z",
    transform: "translate(-155.871)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M305.448,201.2A26.536,26.536,0,0,0,319.8,187.284h-8.32A32.948,32.948,0,0,1,305.448,201.2Z",
    transform: "translate(-246.38 -150.609)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M198.525,97.46H187.408a47.172,47.172,0,0,0,0,14.072h11.117Z",
    transform: "translate(-151.032 -78.375)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M146.261,8.444a26.536,26.536,0,0,0-14.354,13.914h8.32A32.949,32.949,0,0,1,146.261,8.444Z",
    transform: "translate(-106.824 -6.79)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M203.364,202.851V187.284H192.9C194.78,195.481,198.738,201.585,203.364,202.851Z",
    transform: "translate(-155.871 -150.609)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M130.528,111.531a52.353,52.353,0,0,1,0-14.072h-8.953a25.621,25.621,0,0,0,0,14.072Z",
    transform: "translate(-97.723 -78.374)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M131.907,187.284A26.535,26.535,0,0,0,146.261,201.2a32.95,32.95,0,0,1-6.033-13.914Z",
    transform: "translate(-106.824 -150.609)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M55.579,483.705H41.507a1.764,1.764,0,0,0-1.759,1.759v3.518h17.59v-3.518A1.765,1.765,0,0,0,55.579,483.705Z",
    transform: "translate(-32.712 -388.982)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M70.661,291.368v8.8H59.86a7.007,7.007,0,0,0-5.031-5.031v-9.041H51.311v9.041a7.007,7.007,0,0,0-5.031,5.031H35.48v-8.8H3.818v22.867H16.131v7.036h7.036v-7.036H35.48V303.681h10.8a7.007,7.007,0,0,0,13.58,0h10.8v10.554H82.973v7.036H90.01v-7.036h12.313V291.368Zm-56.8,18.839-.264.211a1.327,1.327,0,0,1-.317.158,1.118,1.118,0,0,1-.317.106,2.644,2.644,0,0,1-.352.035,1.76,1.76,0,1,1,.352-3.483,1.122,1.122,0,0,1,.317.106,1.334,1.334,0,0,1,.317.158l.264.211.211.264a1.331,1.331,0,0,1,.158.317,1.117,1.117,0,0,1,.106.317,2.648,2.648,0,0,1,.035.352A1.849,1.849,0,0,1,13.862,310.207Zm7.036,0a1.759,1.759,0,0,1-3.008-1.249,2.654,2.654,0,0,1,.035-.352,1.116,1.116,0,0,1,.106-.317,1.331,1.331,0,0,1,.158-.317l.211-.264a1.842,1.842,0,0,1,2.5,0A1.784,1.784,0,0,1,20.9,310.207Zm7.036,0a2.029,2.029,0,0,1-.58.369,1.658,1.658,0,0,1-1.337,0,2.031,2.031,0,0,1-.58-.369,1.85,1.85,0,0,1-.51-1.249,2.654,2.654,0,0,1,.035-.352,1.116,1.116,0,0,1,.106-.317,1.331,1.331,0,0,1,.158-.317,2.8,2.8,0,0,1,.211-.264,1.842,1.842,0,0,1,2.5,0,2.824,2.824,0,0,1,.211.264,1.331,1.331,0,0,1,.158.317,1.116,1.116,0,0,1,.106.317,2.647,2.647,0,0,1,.035.352A1.85,1.85,0,0,1,27.934,310.207Zm52.771,0-.264.211a1.331,1.331,0,0,1-.317.158,1.118,1.118,0,0,1-.317.106,2.644,2.644,0,0,1-.352.035,1.76,1.76,0,1,1,.352-3.483,1.122,1.122,0,0,1,.317.106,1.335,1.335,0,0,1,.317.158l.264.211.211.264a1.331,1.331,0,0,1,.158.317,1.117,1.117,0,0,1,.106.317,2.646,2.646,0,0,1,.035.352A1.851,1.851,0,0,1,80.7,310.207Zm7.036,0a1.759,1.759,0,0,1-3.008-1.249,2.655,2.655,0,0,1,.035-.352,1.116,1.116,0,0,1,.106-.317,1.331,1.331,0,0,1,.158-.317l.211-.264a1.842,1.842,0,0,1,2.5,0A1.784,1.784,0,0,1,87.741,310.207Zm7.036,0a2.029,2.029,0,0,1-.58.369,1.658,1.658,0,0,1-1.337,0,2.03,2.03,0,0,1-.58-.369,1.85,1.85,0,0,1-.51-1.249,2.656,2.656,0,0,1,.035-.352,1.116,1.116,0,0,1,.106-.317,1.331,1.331,0,0,1,.158-.317,2.8,2.8,0,0,1,.211-.264,1.842,1.842,0,0,1,2.5,0,2.826,2.826,0,0,1,.211.264,1.331,1.331,0,0,1,.158.317,1.116,1.116,0,0,1,.106.317,2.648,2.648,0,0,1,.035.352A1.849,1.849,0,0,1,94.777,310.207Z",
    transform: "translate(-3.818 -230.066)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M396.912,483.705H382.84a1.764,1.764,0,0,0-1.759,1.759v3.518h17.59v-3.518A1.765,1.765,0,0,0,396.912,483.705Z",
    transform: "translate(-307.202 -388.982)",
    fill: "#e8eaf0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.f70df2f0dfdb68b708aefb04612e9a6c.svg";
export { ForwardRef as ReactComponent };